"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ViewAllWrapper = exports.ViewAllButtonSkeleton = exports.Root = void 0;
var _mui = require("@ori-ui/mui");
var _styles = require("../../containers/Widget/styles");
var _styles2 = require("../styles");
const Root = exports.Root = (0, _mui.styled)(_styles.WidgetRoot)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center'
}));
const ViewAllButtonSkeleton = exports.ViewAllButtonSkeleton = (0, _mui.styled)(_styles2.UnifiedSkeleton)(({
  theme
}) => ({
  width: 110,
  height: 45,
  borderRadius: theme.spacing(5),
  transform: 'none'
}));
const ViewAllWrapper = exports.ViewAllWrapper = (0, _mui.styled)(_styles.ViewAll)(({
  theme
}) => ({
  margin: theme.spacing(8, 'auto', 3),
  [theme.breakpoints.up('lg')]: {
    margin: 0
  }
}));
